/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/internalPostExperimentStratifiedSamplingOverrides';
import type { InternalPostExperimentStratifiedSamplingRequestBody } from '../../operation-overrides/internalPostExperimentStratifiedSamplingOverrides';

export type InternalPostExperimentStratifiedSamplingPathParams = NonNullable<
  operations['internalPostExperimentStratifiedSampling']['parameters']['path']
>;

export type { InternalPostExperimentStratifiedSamplingRequestBody };

export interface Input extends InternalPostExperimentStratifiedSamplingPathParams {
  apiVersion?: string;
  body: InternalPostExperimentStratifiedSamplingRequestBody;
  header: NonNullable<operations['internalPostExperimentStratifiedSampling']['parameters']['header']>;
}

export async function internalPostExperimentStratifiedSampling(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST(
    '/internal/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/stratified-sampling',
    {
      params: { path, header },
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      body,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      bodySerializer: overrides.bodySerializer,
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
